import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { backendUrl } from '../../utils/constants/url';
import { TRefreshRequest, type TAuthRequest, type TAuthResponse } from '../types/AuthTypes';

export const AuthApi = createApi({
  reducerPath: 'AuthApi',
  tagTypes: ['Auth'],
  baseQuery: fetchBaseQuery({ baseUrl: `${backendUrl}/auth` }),
  endpoints: (build) => ({
    auth: build.mutation<TAuthResponse, TAuthRequest>({
      query: (body: TAuthRequest) => ({
        url: 'token/login/',
        method: 'POST',
        body,
      }),
      transformResponse: (response: TAuthResponse) => {
        if (!response.trader) {
          throw new Error('Invalid username or password');
        }
        return response;
      },
    }),
    refresh: build.mutation<TAuthResponse, TRefreshRequest>({
      query: (body: TRefreshRequest) => ({
        url: 'token/refresh/',
        method: 'POST',
        body,
      }),
      transformErrorResponse: (response: any) => {
        if (response.status === 401 || response.status === 403) {
          window.location.href = '/';
          localStorage.removeItem('refresh_token');
        }
      },
    }),
  }),
});

export const { useAuthMutation, useRefreshMutation } = AuthApi;
